import React from "react";
import { InnerWrapper, OuterWrapper } from "../wrapper/wrapper";
import { Container, GetStartedButton, Text } from "./contact.components";
import Person from "../../images/homepage/contact-person.png";
import { Link } from "react-router-dom";
import { Box, Stack } from "@mui/material";

function Contact(props) {
  return (
    <OuterWrapper
      sx={{ py: "150px", backgroundColor: props.colorBackground || "#EAEEF2" }}
    >
      <InnerWrapper>
        <Container
          sx={{
            width: { xs: "96%", md: 950 },
            height: { xs: 600, md: 300 },
            mx: { xs: "10px", md: "auto" },
          }}
        >
          <Box
            component="img"
            src={Person}
            alt=""
            sx={{
              width: { xs: 250, md: 300 },
              position: "absolute",
              bottom: 0,
              left: { xs: "15%", md: "9%" },
            }}
          />
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={4.3}
            sx={{
              position: "absolute",
              left: { xs: 0, md: "42%" },
              top: { xs: "7%", md: "19%" },
            }}
          >
            <Text
              sx={{ pl: { xs: "30px", md: "initial" }, width: { md: 500 } }}
            >
              {props.text}
            </Text>
            <GetStartedButton component={Link} to={props.url}>
              {props.buttonText}
            </GetStartedButton>
          </Stack>
        </Container>
      </InnerWrapper>
    </OuterWrapper>
  );
}

export default Contact;
